module.exports = __webpack_public_path__ + "img/home.b6d70df1.svg";